<template>
    <div class="wrap">
        <div class="title">
            <div class="title_left">预警考核统计</div>
        </div>
        <div class="innerBox">
            <div class="ipt-btn-box mb20">
                <span class=" mr10">月份筛选:</span>
                <el-date-picker class="w160 mr20" v-model="queryLimit.month" type="month" :clearable="true" @change="searchPage" placeholder="选择月份"
                                value-format="yyyy-MM" :picker-options="pickerOptions">
                </el-date-picker>
            </div>
            <!-- <div class="ipt-btn-box mb20">
                总计:<span style="font-size: 22px;color: #393939;margin: 0 10px;">{{total}}</span>个主体
            </div> -->
            <div class="table mb20">
                <el-table v-loading="loading" element-loading-text="数据正在努力加载中" :border="true" :resizable="true" :data="tableData" class="table-div">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="streetName" min-width="120" label='辖区名称'></el-table-column>
                    <el-table-column show-overflow-tooltip prop="entityTypeStr" min-width="120" label='主体业态'></el-table-column>
                    <el-table-column show-overflow-tooltip prop="entityName" min-width="190" label="主体名称"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="totalScore" min-width="120" label="考核得分"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="totalDeduction" min-width="100" label="本月累计扣分"></el-table-column>
                    <el-table-column v-for='(item,i) in configEwTypeList' :key="item.key+i" show-overflow-tooltip
                                     :prop="item.key === 'FOOD' ? 'FOOD_EXPIRED' : item.key" min-width="100" :label="item.value"></el-table-column>
                </el-table>
            </div>
        </div>

    </div>

</template>

<script>
import * as api from 'api/warning_v2.js';
import Cookies from "js-cookie";

export default {
    components: {},
    data() {
        return {
            queryLimit: {
                month: ''
            },
            total: 0,
            configEwTypeList: [],
            tableData: [],
            loading: false,
            pickerOptions: {
                disabledDate(time) {
                    let date = new Date("2018-12-31");
                    return time.getTime() > Date.now() - 8.64e6 || time.getTime() < date;
                }
            },
        };
    },
    async mounted() {
        this.searchPage();
    },
    methods: {
        async searchPage() {
            this.tableData = [];
            this.loading = true;
            let data = {
                ...this.queryLimit,
                entityId: this.$store.state.common.user.deptId,
                areaCode: Cookies.get('areaId'),
            }
            let result = await api.getStatisticsList(data);
            if (result.code == 200) {
                this.tableData = result.data.records;
                this.configEwTypeList = result.data.configEwTypeList;
                this.total = result.data.total
            } else {
                this.$message.warning(result.message);
            }
            this.loading = false;
        },
    }
};
</script>
<style scoped lang="scss">
.wrap {
    width: calc(100% - 40px);
    padding: 0 20px;
    height: 100%;
    background: #f6f6f6;

    .title {
        height: 60px;
        line-height: 60px;

        .title_left {
            font-size: 20px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            width: 50%;
            height: 100%;
        }
    }

    .innerBox {
        width: calc(100% - 60px);
        padding: 20px 30px;
        min-height: calc(100% - 125px);
        background: #fff;
        border-radius: 10px;
        margin-bottom: 30px;
    }
}

.pagination-box {
    text-align: right;
    margin-top: 20px;
}

.table-div {
    width: 100%;
    text-align: center;
}

.operate-a {
    color: #1787ad;
}

table tr td:last-child .cell a {
    border-right: 1px solid #ccc;
    padding-right: 5px;
}

table tr td:last-child .cell a:last-child {
    border-right: none;
    padding-right: 0px;
}

.table {
    padding-bottom: 100px;
}
</style>